<template>
  <div>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import tablePage from '@/components/page/table'
import Qs from 'qs'
import DateUtil from '@/utils/IM/tradeDataUtil'

let statusArr = { 0: '待审批', 1: '已审批', 2: '已拒絕' }

export default {
  name: 'personnelApply',
  components: {
    tablePage
  },
  data() {
    return {
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.personnelApplyList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '姓名', field: 'name' },
          { title: '前綴', field: 'mobilePhonePrefix' },
          { title: '手机号', field: 'phone' },
          { title: '邮箱', field: 'email' },
          { title: '關聯賬號', field: 'customerNumber' },
          {
            title: '申請時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '状态', field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          { title: '上級代理', field: 'pCode' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'analyse:personnelApply:del'
              },
              {
                name: window.$t('common.approve'),
                click: 'approve',
                type: 'primary',
                icon: 'el-icon-approve',
                auth: 'analyse:personnelApply:approve', hidden: (data, full) => {
                  return full.status != 0
                }
              },
              {
                name: window.$t('common.reject'),
                click: 'reject',
                type: 'primary',
                icon: 'el-icon-reject',
                auth: 'analyse:personnelApply:reject', hidden: (data, full) => {
                  return full.status != 0
                }
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'delete') {
        let option = {
          id: row.id
        }
        this.dataChange(Url.adAgent.personnelApplyDel, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'reject' || clickName == 'approve') {
        let option = {
          id: row.id,
          status: clickName == 'approve' ? 1 : 2
        }
        this.dataChange(Url.adAgent.personnelApplyStatus, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    }
  },
  mounted() {
    this.$refs.childTable.defaultGetData()
  }
}
</script>

<style scoped>

</style>
